export default "__VITE_ASSET__Do7xrCn2__"